import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Ponerle nombre sin culparme",
    opening: localizedGenderNode(
      [
      "Hoy no estoy “dañado/a”. Hoy simplemente noto: me cuesta abrirme."
    ],
      [
      "Hoy no estoy “dañado/a”. Hoy simplemente noto: me cuesta abrirme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Mi cierre es protección, no un defecto.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Mi cierre es protección, no un defecto.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo siento que me “cierro” en las citas?\n[Escribe aquí]",
      "2. ¿Qué me da miedo que vean en mí si me abro?\n[Escribe aquí]",
      "3. ¿Dónde en mi cuerpo siento este cierre?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo siento que me “cierro” en las citas?\n[Escribe aquí]",
      "2. ¿Qué me da miedo que vean en mí si me abro?\n[Escribe aquí]",
      "3. ¿Dónde en mi cuerpo siento este cierre?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy no lucho contra esto. Estoy aprendiendo a reconocer mi protección con suavidad."
    ],
      [
      "Cierre",
      "Hoy no lucho contra esto. Estoy aprendiendo a reconocer mi protección con suavidad."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + la frase: “Tengo permiso para abrirme despacio.”",
      "Una vez hoy: una respiración + la frase: “Tengo permiso para abrirme despacio.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué pasa exactamente en el momento en que me cierro",
    opening: localizedGenderNode(
      [
      "Hoy observo el pequeño momento en que cambio."
    ],
      [
      "Hoy observo el pequeño momento en que cambio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Observo, no juzgo.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Observo, no juzgo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es el disparador común que me cierra? (una pregunta, una mirada, el silencio, el contacto, una expectativa)\n[Escribe aquí]",
      "2. ¿Cuál es el primer pensamiento que aparece?\n[Escribe aquí]",
      "3. ¿Qué hago inmediatamente después? (humor, cambiar de tema, distanciarme, teléfono)\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es el disparador común que me cierra? (una pregunta, una mirada, el silencio, el contacto, una expectativa)\n[Escribe aquí]",
      "2. ¿Cuál es el primer pensamiento que aparece?\n[Escribe aquí]",
      "3. ¿Qué hago inmediatamente después? (humor, cambiar de tema, distanciarme, teléfono)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando reconozco el momento — ya comienza una elección."
    ],
      [
      "Cierre",
      "Cuando reconozco el momento — ya comienza una elección."
    ]
    ),
    action: localizedGenderNode(
      "La próxima vez que me cierre: una pausa de 10 segundos antes de “escapar”.",
      "La próxima vez que me cierre: una pausa de 10 segundos antes de “escapar”."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El miedo de abajo (rechazo / vergüenza / quedar expuesto/a)",
    opening: localizedGenderNode(
      [
      "Hoy identifico el miedo real debajo de mi cierre."
    ],
      [
      "Hoy identifico el miedo real debajo de mi cierre."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Mi miedo intenta protegerme.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Mi miedo intenta protegerme.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué temo más: ser rechazado/a, ser herido/a o ser visto/a?\n[Escribe aquí]",
      "2. ¿Qué frase vieja creo sobre el amor/la relación?\n[Escribe aquí]",
      "3. ¿Qué frase más suave puede reemplazarla hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué temo más: ser rechazado/a, ser herido/a o ser visto/a?\n[Escribe aquí]",
      "2. ¿Qué frase vieja creo sobre el amor/la relación?\n[Escribe aquí]",
      "3. ¿Qué frase más suave puede reemplazarla hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo no tiene que desaparecer para que yo sea un poco más real."
    ],
      [
      "Cierre",
      "El miedo no tiene que desaparecer para que yo sea un poco más real."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase suave y la guardo: “Puedo ser yo, despacio.”",
      "Escribo una frase suave y la guardo: “Puedo ser yo, despacio.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "“Abrirme” no significa contarlo todo",
    opening: localizedGenderNode(
      [
      "Hoy defino la apertura de una manera segura."
    ],
      [
      "Hoy defino la apertura de una manera segura."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La apertura puede ser pequeña.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La apertura puede ser pequeña.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué es “apertura segura” para mí? (un ejemplo)\n[Escribe aquí]",
      "2. ¿Qué es “demasiada apertura” para mí?\n[Escribe aquí]",
      "3. ¿Qué límite sano me ayudaría a sentirme protegido/a?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué es “apertura segura” para mí? (un ejemplo)\n[Escribe aquí]",
      "2. ¿Qué es “demasiada apertura” para mí?\n[Escribe aquí]",
      "3. ¿Qué límite sano me ayudaría a sentirme protegido/a?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que abrirme rápido. Construyo confianza a mi ritmo."
    ],
      [
      "Cierre",
      "No tengo que abrirme rápido. Construyo confianza a mi ritmo."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una cosa pequeña para contar la próxima vez — nada más.",
      "Elijo una cosa pequeña para contar la próxima vez — nada más."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El cuerpo en las citas (congelación / tensión / desconexión)",
    opening: localizedGenderNode(
      [
      "Hoy escucho a mi cuerpo en lugar de pelear con él."
    ],
      [
      "Hoy escucho a mi cuerpo en lugar de pelear con él."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta. “El cuerpo habla.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta. “El cuerpo habla.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cómo se comporta mi cuerpo en una cita? (congelado/a, tenso/a, contraído/a, demasiado correcto/a)\n[Escribe aquí]",
      "2. ¿Qué me pide mi cuerpo en ese momento? (aire, espacio, una pausa, agua)\n[Escribe aquí]",
      "3. ¿Qué acción pequeña ayudaría a mi cuerpo a calmarse?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cómo se comporta mi cuerpo en una cita? (congelado/a, tenso/a, contraído/a, demasiado correcto/a)\n[Escribe aquí]",
      "2. ¿Qué me pide mi cuerpo en ese momento? (aire, espacio, una pausa, agua)\n[Escribe aquí]",
      "3. ¿Qué acción pequeña ayudaría a mi cuerpo a calmarse?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando calmo mi cuerpo — mi corazón tiene espacio."
    ],
      [
      "Cierre",
      "Cuando calmo mi cuerpo — mi corazón tiene espacio."
    ]
    ),
    action: localizedGenderNode(
      "Práctica de “respiración baja”: 3 respiraciones al abdomen, una vez.",
      "Práctica de “respiración baja”: 3 respiraciones al abdomen, una vez."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La voz interior que me critica en las citas",
    opening: localizedGenderNode(
      [
      "Hoy reemplazo la crítica por una voz que me sostiene."
    ],
      [
      "Hoy reemplazo la crítica por una voz que me sostiene."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “No tengo que demostrar.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “No tengo que demostrar.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué frase crítica se repite en mí?\n[Escribe aquí]",
      "2. ¿Cómo le hablaría a un buen amigo en mi lugar?\n[Escribe aquí]",
      "3. ¿Cómo suena esa frase en una versión suave?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué frase crítica se repite en mí?\n[Escribe aquí]",
      "2. ¿Cómo le hablaría a un buen amigo en mi lugar?\n[Escribe aquí]",
      "3. ¿Cómo suena esa frase en una versión suave?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una voz suave no me hace débil. Me permite ser real."
    ],
      [
      "Cierre",
      "Una voz suave no me hace débil. Me permite ser real."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: respondo a la crítica con mi frase suave.",
      "Una vez hoy: respondo a la crítica con mi frase suave."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Exposición limpia (ACT suave): quedarme un minuto más",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme dentro de la incomodidad sin huir."
    ],
      [
      "Hoy practico quedarme dentro de la incomodidad sin huir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Puedo sostener un minuto.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Puedo sostener un minuto.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué momento tiendo a huir?\n[Escribe aquí]",
      "2. Si me quedo un minuto más — ¿qué temo que pase?\n[Escribe aquí]",
      "3. ¿Qué pasó en realidad cuando me quedé un minuto más (aunque sea en imaginación)?\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué momento tiendo a huir?\n[Escribe aquí]",
      "2. Si me quedo un minuto más — ¿qué temo que pase?\n[Escribe aquí]",
      "3. ¿Qué pasó en realidad cuando me quedé un minuto más (aunque sea en imaginación)?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El valor no es una gran apertura. El valor es un minuto más."
    ],
      [
      "Cierre",
      "El valor no es una gran apertura. El valor es un minuto más."
    ]
    ),
    action: localizedGenderNode(
      "La próxima vez: “un minuto más” antes de cerrarme.",
      "La próxima vez: “un minuto más” antes de cerrarme."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Poner límites sin cerrarme",
    opening: localizedGenderNode(
      [
      "Hoy aprendo: un límite puede ser abierto."
    ],
      [
      "Hoy aprendo: un límite puede ser abierto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Un límite es protección, no un muro.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Un límite es protección, no un muro.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde necesito un límite en las citas?\n[Escribe aquí]",
      "2. ¿Cómo puedo decir un límite con suavidad?\n[Escribe aquí]",
      "3. ¿Qué miedo rodea poner un límite?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde necesito un límite en las citas?\n[Escribe aquí]",
      "2. ¿Cómo puedo decir un límite con suavidad?\n[Escribe aquí]",
      "3. ¿Qué miedo rodea poner un límite?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando hay un límite — la armadura se necesita menos."
    ],
      [
      "Cierre",
      "Cuando hay un límite — la armadura se necesita menos."
    ]
    ),
    action: localizedGenderNode(
      "Preparo una frase suave de límite para usar en el futuro.",
      "Preparo una frase suave de límite para usar en el futuro."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Quién soy cuando no “actúo”",
    opening: localizedGenderNode(
      [
      "Hoy suelto el desempeño y vuelvo a mi humanidad."
    ],
      [
      "Hoy suelto el desempeño y vuelvo a mi humanidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “No soy un espectáculo.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “No soy un espectáculo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué intento “parecer” en una cita?\n[Escribe aquí]",
      "2. ¿Qué me pasa cuando intento impresionar?\n[Escribe aquí]",
      "3. ¿Qué verdad humana estoy dispuesto/a a traer?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué intento “parecer” en una cita?\n[Escribe aquí]",
      "2. ¿Qué me pasa cuando intento impresionar?\n[Escribe aquí]",
      "3. ¿Qué verdad humana estoy dispuesto/a a traer?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La gente se conecta con la verdad, no con la perfección."
    ],
      [
      "Cierre",
      "La gente se conecta con la verdad, no con la perfección."
    ]
    ),
    action: localizedGenderNode(
      "Practico una frase simple: “La verdad, me cuesta un poco abrirme despacio.”",
      "Practico una frase simple: “La verdad, me cuesta un poco abrirme despacio.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "La confianza se construye en porciones pequeñas",
    opening: localizedGenderNode(
      [
      "Hoy no busco “chispa”. Construyo confianza."
    ],
      [
      "Hoy no busco “chispa”. Construyo confianza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La confianza es un proceso.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La confianza es un proceso.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué me hace sentir seguro/a con una persona?\n[Escribe aquí]",
      "2. ¿Cuál es una señal pequeña de que esta es una persona segura?\n[Escribe aquí]",
      "3. ¿Cuál es una señal pequeña de que no lo es?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué me hace sentir seguro/a con una persona?\n[Escribe aquí]",
      "2. ¿Cuál es una señal pequeña de que esta es una persona segura?\n[Escribe aquí]",
      "3. ¿Cuál es una señal pequeña de que no lo es?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que abrirme con alguien que no me da seguridad."
    ],
      [
      "Cierre",
      "No tengo que abrirme con alguien que no me da seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo 2 señales de “seguro” y 2 señales de “no seguro” y las guardo.",
      "Escribo 2 señales de “seguro” y 2 señales de “no seguro” y las guardo."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Hacer una pregunta real en lugar de esconderme",
    opening: localizedGenderNode(
      [
      "Hoy creo conexión a través de la curiosidad, no del esfuerzo."
    ],
      [
      "Hoy creo conexión a través de la curiosidad, no del esfuerzo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La curiosidad abre con suavidad.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La curiosidad abre con suavidad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué me gustaría saber de verdad sobre la persona frente a mí?\n[Escribe aquí]",
      "2. ¿Cuál es una pregunta simple que puedo hacer?\n[Escribe aquí]",
      "3. ¿Qué me da miedo preguntar y por qué?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué me gustaría saber de verdad sobre la persona frente a mí?\n[Escribe aquí]",
      "2. ¿Cuál es una pregunta simple que puedo hacer?\n[Escribe aquí]",
      "3. ¿Qué me da miedo preguntar y por qué?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Abrirse también es preguntar, no solo contar."
    ],
      [
      "Cierre",
      "Abrirse también es preguntar, no solo contar."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una pregunta “real” para mi próxima cita.",
      "Elijo una pregunta “real” para mi próxima cita."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cuando una cita “no funciona” sin cargarlo sobre mí",
    opening: localizedGenderNode(
      [
      "Hoy separo compatibilidad de valor personal."
    ],
      [
      "Hoy separo compatibilidad de valor personal."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La incompatibilidad no es rechazo de quien soy.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “La incompatibilidad no es rechazo de quien soy.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué interpreto enseguida como fracaso?\n[Escribe aquí]",
      "2. ¿Cuál es otra explicación posible, más neutral?\n[Escribe aquí]",
      "3. ¿Qué quiero recordar sobre mi valor incluso si no funciona?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué interpreto enseguida como fracaso?\n[Escribe aquí]",
      "2. ¿Cuál es otra explicación posible, más neutral?\n[Escribe aquí]",
      "3. ¿Qué quiero recordar sobre mi valor incluso si no funciona?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No me miden por una sola cita."
    ],
      [
      "Cierre",
      "No me miden por una sola cita."
    ]
    ),
    action: localizedGenderNode(
      "Después de una interacción: escribo 1 cosa que hice bien.",
      "Después de una interacción: escribo 1 cosa que hice bien."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“Estoy listo/a para una relación” a mi manera",
    opening: localizedGenderNode(
      [
      "Hoy formulo lo que realmente quiero en una relación."
    ],
      [
      "Hoy formulo lo que realmente quiero en una relación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Tengo permiso para querer una relación que me quede bien.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración. “Tengo permiso para querer una relación que me quede bien.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cómo quiero sentirme dentro de una relación?\n[Escribe aquí]",
      "2. ¿Qué valor debe estar sí o sí?\n[Escribe aquí]",
      "3. ¿Qué límite me protegerá en mi próxima relación?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cómo quiero sentirme dentro de una relación?\n[Escribe aquí]",
      "2. ¿Qué valor debe estar sí o sí?\n[Escribe aquí]",
      "3. ¿Qué límite me protegerá en mi próxima relación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La claridad crea seguridad."
    ],
      [
      "Cierre",
      "La claridad crea seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una “frase de dirección” para mi próxima relación y la guardo.",
      "Escribo una “frase de dirección” para mi próxima relación y la guardo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave: abrirme despacio es una habilidad",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con lealtad hacia mí."
    ],
      [
      "Hoy cierro el viaje con lealtad hacia mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta. “No llego tarde. Soy preciso/a conmigo.”"
    ],
      [
      "Hago una pausa conmigo.",
      "Una respiración lenta. “No llego tarde. Soy preciso/a conmigo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué aprendí sobre mi protección?\n[Escribe aquí]",
      "2. ¿Qué paso pequeño de apertura estoy dispuesto/a a mantener?\n[Escribe aquí]",
      "3. Una frase de regreso para días de cierre:\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué aprendí sobre mi protección?\n[Escribe aquí]",
      "2. ¿Qué paso pequeño de apertura estoy dispuesto/a a mantener?\n[Escribe aquí]",
      "3. Una frase de regreso para días de cierre:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No me obligo a abrirme.",
      "Me enseño a sentirme seguro/a.",
      "Despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del viaje",
      "No me obligo a abrirme.",
      "Me enseño a sentirme seguro/a.",
      "Despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice “apertura pequeña”: un mensaje honesto corto / una conversación corta / una salida sin presión.",
      "Elijo una acción que simbolice “apertura pequeña”: un mensaje honesto corto / una conversación corta / una salida sin presión."
    ),
  },
].map(buildNormalizedDay);

export const difficultyOpeningUpOnDatesBlueprintEs = buildNormalizedPilotBlueprint({
  id: "difficulty_opening_up_on_dates_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "difficulty_opening_up_on_dates",
  category: "general",
  journeyName: {
    he: "קושי להיפתח בדייטים",
    en: "Difficulty Opening Up on Dates",
    es: "Dificultad para abrirme en citas",
  },
  days,
});

export default difficultyOpeningUpOnDatesBlueprintEs;
